export default __webpack_public_path__ + "static/media/brand.bc503ed2.png";